import React from "react"
import PropTypes from "prop-types"
import { Section, CmsImage } from "@bw/bits"
import { Teasers } from "@bw/modules"
import { Teaser } from "@bw/partials"
import dateFormat from "../../../utils/dateFormat"

const Formations = ({ formations }) => {
  if (!formations) {
    return null
  }

  return (
    <Section>
      <Teasers>
        {formations.map((item, k) => (
          <Teaser
            key={k}
            title={item.title}
            excerpt={item.teaserExcerpt}
            image={
              <CmsImage
                src={item.teaserImage || "/placeholder-teaser.jpg"}
                alt={item.title}
              />
            }
            to={item.slug}
          />
        ))}
      </Teasers>
    </Section>
  )
}

Formations.propTypes = {
  formations: PropTypes.array,
}

export { Formations }
